import(/* webpackMode: "eager" */ "/home/ubuntu/download/69bd71337d947e0014dec6b9/lookmax_ai/src/app/not-found.tsx");
